import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable asmTranslations has been removed and is no longer part of the public API. 
import { asmTranslationChunksConfig, asmTranslationsEn } from "@spartacus/asm/assets";
import { AsmRootModule, ASM_FEATURE, AsmConfig } from "@spartacus/asm/root";
import { CmsConfig, ConfigModule, I18nConfig, provideConfig } from "@spartacus/core";
import { translationOverwrites } from '../../../translations/en/custom_asm';

@NgModule({
  declarations: [],
  imports: [
    AsmRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [ASM_FEATURE]: {
        module: () =>
          import('@spartacus/asm').then((m) => m.AsmModule),
      },
    },
    backend: {
      occ: {
          endpoints: {
              // asmCustomerSearch: '/asm/autocomplete',
          }
        }
      }
  }),
  provideConfig(<AsmConfig>{
// TODO:Spartacus - The type of property 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; userIdHttpHeader?: { enable?: boolean; }; }' changed to: 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; asmSessionSupport?: { enabled?: boolean; }; userIdHttpHeader?: { enable?: boolean; }; createCustomer?: { enable?: boolean; }; }' 
    asm : {
      userIdHttpHeader: {
        enable: true,
      },
    },
  }),
  ]
})
export class AsmFeatureModule { }
